import { Component, OnInit } from '@angular/core';
import {JqueryService} from './lib/service';
import Modo from './enums/modo';
import {ConfigService, LoaderService, PesquisaService} from './lib/service';
import {Router} from '@angular/router';
import {ILoader, IConfig} from './lib/interface';

//CSS Template
import '../../public/css/styles.css';
import '../../public/css/app.min.1.css';
import '../../public/css/app.min.2.css';
import '../../public/css/fi.css';
import { Pesquisa } from './lib/model';

//JS Template
// import '../../public/js/functions.js';





@Component({
  selector: 'template-fi',
  template: require('./app.component.html'),
  styles: ['./app.component.css'],
})


export class AppComponent implements OnInit 
{
  private config: ConfigService;
  private loader: ILoader;
  private nomeUniodonto: string;
  private registroANS: string;


  constructor(private _pesquisaService: PesquisaService,
              private _loaderService: LoaderService,
              private _configService: ConfigService,
              private _router: Router) {
      this.config = this._configService;
      this.config.load();
      this.loader = this._loaderService.loader;
  }

  // getParameterByName(name : string, url? : string) {
  //     if (!url) url = window.location.href;
  //     name = name.replace(/[\[\]]/g, "\\$&");
  //     var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
  //         results = regex.exec(url);
  //     if (!results) return null;
  //     if (!results[2]) return '';
  //     return decodeURIComponent(results[2].replace(/\+/g, " "));
  // }

  ngOnInit()
  {        
    JqueryService.configuraAplicacao(); //Configura alguns detalhes do Jquery para o template  

    //let source = this.getParameterByName('s');

    this.registroANS = window.location.href.split('=')[1];

    if(this.registroANS)
    {
      this._pesquisaService.getNomeUniodonto(this.registroANS)
        .subscribe((result) => {
          //alert(JSON.stringify(result));
          this.nomeUniodonto = result;
        }, (error) => {
          alert(error);
        })
    }
  }

  imprimirGuiaCompleto() {
    this._loaderService.showLoader();

    const pesquisa = new Pesquisa();
    pesquisa.registroANS = this.registroANS;
    pesquisa.isRedeNacional = false;
    pesquisa.skip = 0;
    pesquisa.take = 9999;
    pesquisa.uf = null;
    pesquisa.cidade = null;
    this._pesquisaService.imprimir(pesquisa)
        .subscribe((result: any) => {
            this._loaderService.hideLoader();
            var win = window.open(result, '_blank');
            win.focus();                
        }, (error) => {
            alert(error);
            this._loaderService.hideLoader();
        })
  }

  getModo() {
    let modo = localStorage.getItem('modo');
    return modo || Modo.encontreSeuDentista;
  }
}


/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/app.component.ts
 **/